import React, { useEffect } from 'react';

import PageContainer from 'Components/Atoms/PageContainer';
import WithDrawer from 'Components/Templates/WithDrawer';

import PersonalSettingsMenu from 'Components/Organisms/PersonalSettingsMenu';

const PersonalSettings: React.FC = () => {
  useEffect(() => {
    document.title = 'Personal Settings - Orion';
  }, []);

  return (
    <WithDrawer>
      <PageContainer>
        <PersonalSettingsMenu />
      </PageContainer>
    </WithDrawer>
  );
};

export default PersonalSettings;
